import { useApolloClient } from "@apollo/client/react";
import workBlockInfo from "./workBlockInfo.gql";

export default function useGetWorkBlockFromCache() {
  const client = useApolloClient();

  return (id) =>
    client.readFragment({
      fragment: workBlockInfo,
      fragmentName: "workBlockInfo",
      id: `WorkBlock:${id}`,
    });
}
